import { Injectable, OnDestroy } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Subscription } from 'rxjs/Subscription';

import * as firebase from 'firebase/app';

import { Role } from '../users/shared/role';
import { RoleService } from '../users/shared/role.service';
import { User } from '../users/shared/user';
import { UserService } from '../users/shared/user.service';

@Injectable()
export class AuthService implements OnDestroy {
  private _auth: firebase.User;
  user: User;
  private _roleSubscription: Subscription;
  role: Role;

  constructor(private afAuth: AngularFireAuth, private userService: UserService, private roleService: RoleService) {
    this.afAuth.authState.subscribe(auth => this.auth = auth);
  }

  ngOnDestroy() {
    this.roleSubscription = null;
  }

  login() {
    return this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());

    // GithubAuthProvider
  }

  logout() {
    return this.afAuth.auth.signOut();
  }

  getIdToken() {
    return this.auth.getIdToken();
  }

  get uid(): string {
    return this.auth ? this.auth.uid : null;
  }

  get auth(): firebase.User {
    return this._auth;
  }

  set auth(auth: firebase.User) {
    this._auth = auth;
    this.role = null;
    this.roleSubscription = null;

    if (this.auth) {
      this.user = this.toUser(this.auth);
      this.userService.update(this.auth.uid, this.user);
      this.roleSubscription = this.roleService.readChild(this.auth.uid).subscribe(role => this.role = role);
    }
  }

  get roleSubscription(): Subscription {
    return this._roleSubscription;
  }

  set roleSubscription(value: Subscription) {
    if (this._roleSubscription) {
      this._roleSubscription.unsubscribe();
    }

    this._roleSubscription = value;
  }

  get isAuthenticated() {
    return !!this.auth && this.user;
  }

  get isInstructor() {
    return this.role && this.role.instructor;
  }

  get isContentManager() {
    return this.role && this.role.contentmanager;
  }

  updateProfile(user: User) {
    this.auth.updateProfile({
      displayName: user.name,
      photoURL: user.avatarUrl
    });

    this.userService.update(this.auth.uid, user);
  }

  private toUser(user: firebase.User) {
    return user ? Object.assign(new User(), {
      name: user.displayName || '익명의 사용자',
      email: user.email,
      avatarUrl: user.photoURL
    }) : null;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/core/auth.service.ts